module.exports = __webpack_public_path__ + "img/95.a6e0c9c2.jpg";